import { Card, Group, Title, Grid, Text, Center, Loader, Button, Divider, Badge, CopyButton, ActionIcon, Tooltip } from "@mantine/core"
import { IconAdjustmentsHorizontal, IconCheck, IconCopy } from "@tabler/icons-react"
import moment from "moment"

import { useProgramsQuery, useProgramActivitiesQuery, useProgramActivitySessionsQuery } from "../../api/program.api";
import { useTransactionByIdQuery } from "../../api/transaction.api";
import { useProgramRegistrationState } from "../../state/programregistration.state";
import { formatAddress, getProgramRegistrationTotal } from "../../functions/programregistration.functions";
import { TransactionPaymentMethod } from "../../models/transaction.models";
import PaymentEditor from "./PaymentEditor";
import PaymentRefundEditor from "./PaymentRefundEditor";
import { currency } from "../../shared/helpers";
import { getTransactionPaymentMethodDescription } from "../../functions/transaction.functions";

const PaymentView = () => {
	const { programRegistration, isLoading: isLoadingRegistration, status, isChanged } = useProgramRegistrationState();
	const { data: programs, isLoading: isLoadingPrograms } = useProgramsQuery();
	const { data: programActivities } = useProgramActivitiesQuery();
	const { data: programActivitySessions } = useProgramActivitySessionsQuery();
	const { data: transaction, isLoading: isLoadingTransaction } = useTransactionByIdQuery(programRegistration.TransactionId ?? 0);
	
	const isSaved = status.isSaved;
	const isTransactionCreated = transaction !== undefined && transaction.PaymentMethod != undefined && transaction.PaymentMethod != TransactionPaymentMethod.None; //status.isPaymentSetup;// programRegistration != null && programRegistration.ProgramId > 0 && programRegistration.ProgramGroupId > 0;
	const isPaidOffline = (programRegistration.Data.Metadata.transaction?.paymentMethod === TransactionPaymentMethod.OfflineCash ||
		programRegistration.Data.Metadata.transaction?.paymentMethod === TransactionPaymentMethod.OfflineDebit ||
		programRegistration.Data.Metadata.transaction?.paymentMethod === TransactionPaymentMethod.OfflineCredit) && programRegistration.Data.Metadata.transaction?.paymentCharged == true;
	const isBillingContactSetup = programRegistration.Data.Metadata.transaction?.billingContact !== undefined || transaction?.Data?.BillingContact !== undefined;
	
	const total = getProgramRegistrationTotal(programRegistration, programs ?? [], programActivities ?? [], programActivitySessions ?? [], true);
	const totalCostExcludingDiscount = getProgramRegistrationTotal(programRegistration, programs ?? [], programActivities ?? [], programActivitySessions ?? []);
	
	const billingContact = transaction?.Data?.BillingContact ?? programRegistration.Data.Metadata.transaction?.billingContact;
	const stripePaymentMethod = programRegistration.Data.Metadata.transaction?.stripePaymentMethod;
	const paymentMethod = programRegistration.Data.Metadata.transaction?.paymentMethod ?? (isTransactionCreated ? transaction.PaymentMethod : undefined);
	const offlinePaymentReference = programRegistration.Data.Metadata.transaction?.offlinePaymentReference;
	const paymentDate = programRegistration.Data.Metadata.transaction?.paymentDate;

	const statusPaidOnline = paymentMethod === TransactionPaymentMethod.ManualStripe && programRegistration.Data.Metadata.transaction?.paymentCharged !== false;

	const statusPaidOffline = (paymentMethod === TransactionPaymentMethod.OfflineCash ||
		paymentMethod === TransactionPaymentMethod.OfflineDebit ||
		paymentMethod === TransactionPaymentMethod.OfflineCredit) && programRegistration.Data.Metadata.transaction?.paymentCharged == true;

	const statusNotCharged = programRegistration.Data.Metadata.transaction?.paymentCharged === false;

	const statusNotPaid = paymentMethod === undefined ||
		// programRegistration.Data.Metadata.transaction?.paymentCharged === false ||
		(paymentMethod === TransactionPaymentMethod.ManualStripe && stripePaymentMethod === undefined);

	// const statusNotCharged = paymentMethod === TransactionPaymentMethod.ManualStripe &&
		// (programRegistration.Data.Metadata.transaction?.paymentCharged === false && stripePaymentMethod !== undefined);

	if (totalCostExcludingDiscount == 0 || (transaction && transaction.Total == 0 && transaction.Paid == 0))
		return <></>

	if (!isTransactionCreated && total <= 0)
		return <Card shadow="lg" withBorder mb="sm" pb="xl">
			<Group justify="space-between" wrap="nowrap">
				<Group gap="xs" mb="lg" wrap="nowrap">
					<IconAdjustmentsHorizontal />
					<Title order={3} lineClamp={1}>Payment Details</Title>
				</Group>
			</Group>

			<Grid mb="xs">
				<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Total:</Text></Grid.Col>
				<Grid.Col span={9} py={0}><Text fw="bold">{currency.format(totalCostExcludingDiscount)}</Text></Grid.Col>
				{totalCostExcludingDiscount - total > 0 && <>
				<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Discount:</Text></Grid.Col>
				<Grid.Col span={9} py={0}><Text fw="bold">{currency.format(totalCostExcludingDiscount - total)}</Text></Grid.Col>
				<Grid.Col span={12}><Divider /></Grid.Col>
				<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Payment Amount:</Text></Grid.Col>
				<Grid.Col span={9} py={0}><Text fw="bold">{currency.format(total)}</Text></Grid.Col>
				</>}
			</Grid>
		</Card>

	return <>
		<Card shadow="lg" withBorder mb="sm" pb="xl">
			<Group justify="space-between" wrap="nowrap">
				<Group gap="xs" mb="lg" wrap="nowrap">
					<IconAdjustmentsHorizontal />
					<Title order={3} lineClamp={1}>Payment Details</Title>
				</Group>
				{/* {!isLoadingRegistration &&
				<DetailsEditor add={!isSetup} />
				} */}
				{/* <Button variant="light" size="xs" mt={-15} mb="md"><IconPencil /> Edit</Button> */}
				{/* <Button variant="light" size="xs" mt={-15} mb="md"><IconPlus /> Add</Button> */}
				<Group gap="xs" wrap="nowrap">
					{isSaved && !isTransactionCreated && !isPaidOffline && <PaymentEditor />}
					{isSaved && (isTransactionCreated || isPaidOffline) && total > 0 && <PaymentRefundEditor />}
				</Group>
			</Group>
			{(isLoadingRegistration || isLoadingTransaction || isLoadingPrograms) && isTransactionCreated && <Center h={150} mx="auto">
				<Loader />
			</Center>}
			{!isTransactionCreated && programRegistration && !isLoadingTransaction && <>
				{/* <Button variant="light" size="sm" mt={0} sx={{ alignSelf: 'flex-start' }}><IconPlus /> Select Program &amp; Dates</Button> */}
				{/* <DetailsEditor add={true} /> */}
				<Grid mb="xs">
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Total:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text fw="bold">{currency.format(totalCostExcludingDiscount)}</Text></Grid.Col>
					{totalCostExcludingDiscount - total > 0 && <>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Discount:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text fw="bold">{currency.format(totalCostExcludingDiscount - total)}</Text></Grid.Col>
					<Grid.Col span={12}><Divider /></Grid.Col>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Payment Amount:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text fw="bold">{currency.format(total)}</Text></Grid.Col>
					</>}
					<Grid.Col span={12}><Divider /></Grid.Col>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Status:</Text></Grid.Col>
					<Grid.Col span={9} py={0}>
						{statusNotPaid &&
							<Badge color="red" mt={2} mb={-2} style={{ display: 'inline-block' }}>Not paid yet</Badge>
						}
						{statusNotCharged &&
							<Badge color="orange" mt={2} mb={-2} style={{ display: 'inline-block' }}>Not charged yet</Badge>
						}
						{statusPaidOnline &&
							<Badge color="green" mt={2} mb={-2} style={{ display: 'inline-block' }}>Paid Online</Badge>
						}
						{statusPaidOffline &&
							<Badge color="green" mt={2} mb={-2} style={{ display: 'inline-block' }}>Paid In-Person</Badge>
						}
					</Grid.Col>
					{paymentMethod !== undefined && <>
						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Method:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text>{getTransactionPaymentMethodDescription(paymentMethod)}</Text></Grid.Col>
					</>}
					{offlinePaymentReference !== undefined && <>
						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">POS Trans. #:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text>{offlinePaymentReference}</Text></Grid.Col>
					</>}
					{paymentDate !== undefined && <>
						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Payment Date:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text>{moment(paymentDate).format("LLL")}</Text></Grid.Col>
					</>}
					{stripePaymentMethod !== undefined && <>
						{/* <Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Method:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text fw="bold">Stripe</Text></Grid.Col> */}
						<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Card:</Text></Grid.Col>
						<Grid.Col span={9} py={0}><Text fw="bold">{stripePaymentMethod.card?.brand.toUpperCase()} **** **** **** {stripePaymentMethod.card?.last4}, Exp: {stripePaymentMethod.card?.exp_month} / {stripePaymentMethod.card?.exp_year}</Text></Grid.Col>
					</>}
				</Grid>
					{!isSaved &&
					<Center h={40} mt="md">
						<Text c="dimmed">Save the registration before adding a payment</Text>
					</Center>
					}
					{isSaved && !stripePaymentMethod && !paymentMethod &&
					<Center h={20} mt="md">
						<Text c="dimmed">Add a payment for this registration</Text>
					</Center>
					}
			</>}
			{!isLoadingRegistration && isTransactionCreated && <>
				<Grid mb="xs">
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Total:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text fw="bold">{currency.format(totalCostExcludingDiscount)}</Text></Grid.Col>
					{totalCostExcludingDiscount - total > 0 && <>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Discount:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text fw="bold">{currency.format(totalCostExcludingDiscount - total)}</Text></Grid.Col>
					</>}
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Paid:</Text></Grid.Col>
					<Grid.Col span={9} py={0}>{transaction ? <Text fw="bold">{currency.format(transaction.Paid)}</Text> : <Badge color="red" mt={2} mb={-2} style={{ display: 'inline-block' }}>Not paid yet</Badge>}</Grid.Col>
					{/* <Grid.Col span={9} py={0}>{transaction ? <Text weight="bold">{currency.format(transaction.Paid)}</Text> : <Badge color="red" mt={2} mb={-2} sx={{ display: 'inline-block' }}>Not paid yet</Badge>}</Grid.Col> */}
					{transaction && <>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Payment Method:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text>{getTransactionPaymentMethodDescription(paymentMethod)}</Text></Grid.Col>
					</>}
					{transaction && <>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Payment ID:</Text></Grid.Col>
					<Grid.Col span={9} py={0}>
						<Group gap={0} wrap="nowrap" mt={-4}>
							<Text truncate>{transaction?.Data?.PaymentData?.id}</Text>
							<CopyButton value={transaction?.Data?.PaymentData?.id ?? ""} timeout={2000}>
								{({ copied, copy }) => (
									<Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
									<ActionIcon color={copied ? 'teal' : 'gray'} variant="subtle" onClick={copy}>
										{copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
									</ActionIcon>
								</Tooltip>
								)}
							</CopyButton>
							{transaction?.Data?.PaymentData?.id &&
							<Button component="a" href={`https://dashboard.stripe.com/payments/${transaction?.Data?.PaymentData?.id}`} target="_blank" variant="subtle" size="compact-sm" miw={115}>Open in Stripe</Button>
							}
						</Group>
					</Grid.Col>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Customer ID:</Text></Grid.Col>
					<Grid.Col span={9} py={0}>
						<Group gap={0} wrap="nowrap" mt={-4}>
							<Text truncate>{transaction?.Data?.CustomerData?.id}</Text>
							<CopyButton value={transaction?.Data?.CustomerData?.id ?? ""} timeout={2000}>
								{({ copied, copy }) => (
									<Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
									<ActionIcon color={copied ? 'teal' : 'gray'} variant="subtle" onClick={copy}>
										{copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
									</ActionIcon>
								</Tooltip>
								)}
							</CopyButton>
							{transaction?.Data?.CustomerData?.id &&
							<Button component="a" href={`https://dashboard.stripe.com/customers/${transaction?.Data?.CustomerData?.id}`} target="_blank" variant="subtle" size="compact-sm">Open in Stripe</Button>
							}
						</Group>
					</Grid.Col>
					</>}
				</Grid>
			</>}
			{!isLoadingRegistration && programRegistration.Refunded > 0 && <>
				<Divider mb="md" label="Refund" labelPosition="center" />
				<Grid mb="xs">
					<Grid.Col span={{ xs: 3, sm: 4, lg: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Refunded:</Text></Grid.Col>
					<Grid.Col span={{ xs: 9, sm: 8, lg: 9 }} py={0}><Text fw="bold">{currency.format(programRegistration.Refunded)}</Text></Grid.Col>
					<Grid.Col span={{ xs: 3, sm: 4, lg: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Date:</Text></Grid.Col>
					<Grid.Col span={{ xs: 9, sm: 8, lg: 9 }} py={0}><Text>{moment(programRegistration.DateRefunded).format("LLL")}</Text></Grid.Col>
					<Grid.Col span={{ xs: 3, sm: 4, lg: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Reason:</Text></Grid.Col>
					<Grid.Col span={{ xs: 9, sm: 8, lg: 9 }} py={0}><Text>{programRegistration.RefundReason}</Text></Grid.Col>
				</Grid>
			</>}
			{!isLoadingRegistration && isBillingContactSetup && <>
				{/* {transaction && <> */}
				<Divider mb="md" label="Billing Contact" labelPosition="center" />
				<Grid mb="xs">
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Name:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text fw="bold">{billingContact?.Salutation} {billingContact?.FirstName} {billingContact?.LastName}</Text></Grid.Col>
					{/* <Grid.Col span={3} sm={2} lg={3} py={0}><Text align="right" color="dimmed" size="sm">Gender:</Text></Grid.Col>
					<Grid.Col span={9} sm={3} lg={9} py={0}><Text>{getGender(transaction?.Data.BillingContact.Gender)}</Text></Grid.Col> */}
				</Grid>
				<Grid mb="xs">
					{billingContact?.Email && <>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Email:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text>{billingContact?.Email}</Text></Grid.Col>
					</>}
					{billingContact?.HomePhone && <>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Home Phone:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text>{billingContact?.HomePhone}</Text></Grid.Col>
					</>}
					{billingContact?.MobilePhone && <>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Cell Phone:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text>{billingContact?.MobilePhone}</Text></Grid.Col>
					</>}
				</Grid>
				{billingContact?.Address && <>
				<Divider mb="md" />
				<Grid>
					<Grid.Col span={3} py={0}><Text ta="right" c="dimmed" size="sm">Address:</Text></Grid.Col>
					<Grid.Col span={9} py={0}><Text>{formatAddress(billingContact.Address)}</Text></Grid.Col>
				</Grid>
				</>}
				{/* </>} */}
			</>}
		</Card>
	</>
}

export default PaymentView